import { FormsMultilineInput, Spinner } from '@platform/components';
import { Control, FormState } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type MatchNeedHelpContentProps = {
  control: Control<UpdateDiscoveryCallFormData>;
  formState: FormState<UpdateDiscoveryCallFormData>;
  isSaving: boolean;
};
export const MatchNeedHelpContent = (props: MatchNeedHelpContentProps) => {
  return (
    <div className='flex flex-col gap-2 items-center md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>
            Let us know what you're struggling with as you make your decision, and a real person
            from our team will follow up with you.
          </div>
          <div className='mt-4'>
            <div className='text-sm'>Additional details</div>
            <FormsMultilineInput
              control={props.control}
              name='needHelpDetails'
              placeholder='Enter details'
              characterCount={500}
              rules={{ required: `Let us know what's going on to continue` }}
              formsError={props.formState.errors['needHelpDetails']}
            />
          </div>
        </>
      }
    </div>
  );
};
